export const formatDate = (dateString: string): string => {
    try {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    } catch {
        return dateString;
    }
};
// Parses ISO (2026-01-15T00:00:00), YYYY-MM-DD and DD-MM-YYYY strings into a local Date.
const parseInvoiceDate = (value?: string | null): Date | null => {
    if (!value) return null;
    const ddmmyyyy = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value);
    const date = ddmmyyyy
        ? new Date(Number(ddmmyyyy[3]), Number(ddmmyyyy[2]) - 1, Number(ddmmyyyy[1]))
        : new Date(value);
    return isNaN(date.getTime()) ? null : date;
};

/**
 * Single source of truth for an invoice's due date in the create/send flow.
 * - Edit mode: keep the invoice's own (possibly user-edited) due date.
 * - New / copied / draft invoices: never reuse a stored due date — it belongs to the
 *   source invoice and is usually already past. Derive it from the invoice date (today
 *   unless given) + the customer's payment term (default 30), matching the backend.
 */
export const resolveInvoiceDueDate = ({
    isEditMode,
    dueDate,
    paymentTerm,
    invoiceDate,
}: {
    isEditMode?: boolean;
    dueDate?: string | null;
    paymentTerm?: string | number | null;
    invoiceDate?: string | null;
}): Date => {
    const storedDueDate = isEditMode ? parseInvoiceDate(dueDate) : null;
    if (storedDueDate) return storedDueDate;

    const result = parseInvoiceDate(invoiceDate) ?? new Date();
    const days = parseInt(String(paymentTerm ?? ''), 10);
    result.setDate(result.getDate() + (Number.isFinite(days) ? days : 30));
    return result;
};

export const formatDateDDMMYYYY = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}-${month}-${date.getFullYear()}`;
};
